import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import jmoment from 'moment-jalaali';
import { formatter, dataGenerator } from '../../../utils';
import * as workingHoursActions from '../../../redux/workingHours/actions';
import ENUMS from '../../../enums';
import styles from './styles.scss';
import * as cafeDiscountsActions from '../../../redux/cafeDiscounts/actions';
import Spin from '../../../components/loading';
import WeekDayDiscountsListItem from './WeekDayDiscountsListItem';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

const CafeDiscounts = props => {
  const [fromDate, setFromDate] = useState();
  const [fromDateInputError, setFromDateInputError] = useState();
  const [toDate, setToDate] = useState();
  const [toDateInputError, setToDateInputError] = useState();
  const [weekdaysDiscounts, setWeekDaysDiscounts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (loaded == false) {
      props.clearCreateDiscountRequestForm();
      props.getMyCafeDailyWorkingHours().then(_ => {
        const generatedList = props.myCafeDailyWorkingHours.map(x => ({
          weekday: x.weekday,
          title: x.title,
          hasDiscount: false,
          hourlyDiscounts:
            x.workingHours &&
            x.workingHours.length &&
            x.workingHours.map(y => ({
              itemKey: dataGenerator.generateKey(x.weekday),
              fromTime: y.fromTime,
              toTime: y.toTime,
              hasDiscount: false,
              discountValue: '',
              discountType: ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values.PERCENT
            }))
        }));
        setWeekDaysDiscounts(generatedList);
        setLoaded(true);
      });
    }
  }, [loaded, props.myCafeDailyWorkingHours]);

  const onChangeFromDate = val => {
    setFromDate(val);
    setFromDateInputError(null);
  };

  const onChangeToDate = val => {
    setToDate(val);
    setToDateInputError(null);
  };

  const validateForm = _ => {
    return new Promise((resolve, reject) => {
      let isFromDateValid = false;
      let isToDateValid = false;

      if (!fromDate) {
        isFromDateValid = false;
        setFromDateInputError(
          locales('messages.fieldValueIsRequired', { fieldName: locales('fields.from.date') })
        );
      } else {
        isFromDateValid = true;
        setFromDateInputError(null);
      }

      if (!toDate) {
        isToDateValid = false;
        setToDateInputError(
          locales('messages.fieldValueIsRequired', { fieldName: locales('fields.to.date') })
        );
      } else {
        isToDateValid = true;
        setToDateInputError(null);
      }

      const isFormValid = isFromDateValid && isToDateValid;

      if (!isFormValid) {
        resolve(false);
      } else {
        resolve(true);
      }
    });
  };

  const onSaveForm = async e => {
    const isFormValid = await validateForm();
    if (!isFormValid) {
      return;
    }

    const mappedWeekdaysDiscounts = [];

    for (const x of weekdaysDiscounts) {
      for (const y of x.hourlyDiscounts) {
        if (y.hasDiscount === true) {
          mappedWeekdaysDiscounts.push({
            weekday: x.weekday,
            fromTime: formatter.toStandard(y.fromTime),
            toTime: formatter.toStandard(y.toTime),
            discountType: y.discountType,
            discountValue: formatter.toStandard(y.discountValue)
          });
        }
      }
    }

    const standardFromDate = formatter.toStandard(jmoment(fromDate).format('jYYYY/jMM/jDD'));
    const standardToDate = formatter.toStandard(jmoment(toDate).format('jYYYY/jMM/jDD'));

    const reqObject = {
      fromDate: standardFromDate,
      toDate: standardToDate,
      hourlyWeekDaysDiscountsList: mappedWeekdaysDiscounts
    };

    props
      .createCafeDiscountRequest(reqObject)
      .then(() => {
        AlertAndConfirmation({
          title: locales('titles.insertedSuccessfully'),
          text: '',
          type: 'success'
        });
        props.history.push('/cafe-discounts');
      })
      .catch(err => console.error(err));
  };

  const onChangeDiscountValue = (weekday, itemKey, value) => {
    const { i, j } = findIndexes(weekday, itemKey);

    if (i >= 0 && j >= 0) {
      let clonedWeekDaysDiscounts = [...weekdaysDiscounts];
      clonedWeekDaysDiscounts[i].hourlyDiscounts[j].discountValue = value;
      setWeekDaysDiscounts(clonedWeekDaysDiscounts);
    }
  };

  const onChangeHasDiscount = (weekday, itemKey, hasDiscount) => {
    const { i, j } = findIndexes(weekday, itemKey);

    if (i >= 0 && j >= 0) {
      let clonedWeekDaysDiscounts = [...weekdaysDiscounts];
      clonedWeekDaysDiscounts[i].hasDiscount =
        hasDiscount ||
        weekdaysDiscounts[i].hourlyDiscounts.some((x, ix) => x.hasDiscount === true && ix !== j);
      clonedWeekDaysDiscounts[i].hourlyDiscounts[j].hasDiscount = hasDiscount;
      clonedWeekDaysDiscounts[i].hourlyDiscounts[j].discountValue = '';
      clonedWeekDaysDiscounts[i].hourlyDiscounts[j].discountType =
        ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values.PERCENT;
      setWeekDaysDiscounts(clonedWeekDaysDiscounts);
    }
  };

  const onChangeDiscountType = (weekday, itemKey, discountType) => {
    const { i, j } = findIndexes(weekday, itemKey);

    if (i >= 0 && j >= 0) {
      let clonedWeekDaysDiscounts = [...weekdaysDiscounts];
      clonedWeekDaysDiscounts[i].hourlyDiscounts[j].discountType = discountType;
      clonedWeekDaysDiscounts[i].hourlyDiscounts[j].discountValue = '';
      setWeekDaysDiscounts(clonedWeekDaysDiscounts);
    }
  };

  const findIndexes = (weekday, itemKey) => {
    for (let i = 0; i < weekdaysDiscounts.length; i++) {
      if (weekdaysDiscounts[i].weekday === weekday) {
        for (let j = 0; j < weekdaysDiscounts[i].hourlyDiscounts.length; j++) {
          if (weekdaysDiscounts[i].hourlyDiscounts[j].itemKey === itemKey) {
            return { i, j };
          }
        }
      }
    }
    return {
      i: -1,
      j: -1
    };
  };

  return (
    <Spin spinning={props.getMyCafeDailyWorkingHoursLoading || props.createCafeDiscountRequestLoading}>
      <section className="page-header">
        <h1>{locales('titles.manage.my.cafe.discounts')}</h1>
        <div className="form-actions">
          <button className="btn btn-success" onClick={onSaveForm}>
            <i className="fa fa-save" />
            {locales('labels.save')}
          </button>
          <Link to="/cafe-discounts" className="btn btn-default">
            <i className="fa fa-reply" />
            {locales('labels.cancel')}
          </Link>
        </div>
      </section>
      <section className="panel panel-default">
        <div className="panel-heading">
          <h3 className="panel-title">
            <i className="fa fa-pencil"></i>
            {locales('titles.add.new.cafe.discount.request')}
          </h3>
        </div>
        <div className="panel-body">
          <form>
            <section>
              <div className="form-row">
                {/* <FailedMessagesList
                  className="col errors-list"
                  messagesList={props.createCafeDiscountRequestFailedMessagesList}
                /> */}
                {(props.createCafeDiscountRequestError || props.tableNumbersError) && (
                  <div
                    className={`col errors-list alert alert-danger alert-dismissible fade show`}
                    role="alert"
                  >
                    {locales('messages.server.error')}
                  </div>
                )}
                {(((!props.createCafeDiscountRequestFailedMessagesList ||
                  !props.createCafeDiscountRequestFailedMessagesList.length) &&
                  props.createCafeDiscountRequestFailed) ||
                  props.tableNumbersFailed) && (
                  <div
                    className={`col errors-list alert alert-danger alert-dismissible fade show`}
                    role="alert"
                  >
                    <ul>
                      {props.createCafeDiscountRequestFailed && (
                        <li>{props.createCafeDiscountRequestMessage}</li>
                      )}
                      {props.tableNumbersMessage && <li>{props.tableNumbersMessage}</li>}
                    </ul>
                  </div>
                )}
              </div>
              <div className="form-row">
                <div className="form-group col d-flex required">
                  <label className="rsee-form-label">{locales('fields.from.date')}</label>
                  <div className="full-width">
                    <DatePicker
                      marge={true}
                      name="fromDate"
                      onChange={onChangeFromDate}
                      value={fromDate}
                      className={`p-0 date-picker-input start rounded py-2 rc-date-input ${
                        !!fromDateInputError ? 'is-invalid' : ''
                      }`}
                    />
                    <div className={`invalid-feedback ${!!fromDateInputError ? 'is-invalid-feedback' : ''}`}>
                      {fromDateInputError}
                    </div>
                  </div>
                </div>
                <div className="form-group col d-flex required">
                  <label className="rsee-form-label">{locales('fields.to.date')}</label>
                  <div className="full-width">
                    <DatePicker
                      marge={true}
                      onChange={onChangeToDate}
                      value={toDate}
                      className={`p-0 date-picker-input start rounded py-2 rc-date-input ${
                        !!toDateInputError ? 'is-invalid' : ''
                      }`}
                      name="toDate"
                    />
                    <div className={`invalid-feedback ${!!toDateInputError ? 'is-invalid-feedback' : ''}`}>
                      {toDateInputError}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className={styles.checkBoxesCol}></th>
                      <th className={styles.weekdaysCol}>{locales('labels.weekday')}</th>
                      <th className={styles.discountsCol}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {weekdaysDiscounts && weekdaysDiscounts.length
                      ? weekdaysDiscounts.map(x => (
                          <WeekDayDiscountsListItem
                            key={x.weekday}
                            weekday={x.weekday}
                            title={x.title}
                            hasDiscountInWeekday={x.hasDiscount}
                            hourlyDiscounts={x.hourlyDiscounts}
                            onChangeDiscountValue={onChangeDiscountValue}
                            onChangeHasDiscount={onChangeHasDiscount}
                            onChangeDiscountType={onChangeDiscountType}
                          />
                        ))
                      : null}
                  </tbody>
                </table>
              </div>
            </section>
          </form>
        </div>
      </section>
    </Spin>
  );
};

const mapStateToProps = state => {
  return {
    getMyCafeDailyWorkingHoursLoading: state.workingHoursReducer.getMyCafeDailyWorkingHoursLoading,
    getMyCafeDailyWorkingHoursFailed: state.workingHoursReducer.getMyCafeDailyWorkingHoursFailed,
    getMyCafeDailyWorkingHoursError: state.workingHoursReducer.getMyCafeDailyWorkingHoursError,
    getMyCafeDailyWorkingHoursMessage: state.workingHoursReducer.getMyCafeDailyWorkingHoursMessage,
    myCafeDailyWorkingHours: state.workingHoursReducer.myCafeDailyWorkingHours,

    createCafeDiscountRequestLoading: state.cafeDiscountsReducer.createCafeDiscountRequestLoading,
    createCafeDiscountRequestFailed: state.cafeDiscountsReducer.createCafeDiscountRequestFailed,
    createCafeDiscountRequestError: state.cafeDiscountsReducer.createCafeDiscountRequestError,
    createCafeDiscountRequestMessage: state.cafeDiscountsReducer.createCafeDiscountRequestMessage,
    createCafeDiscountRequestFailedMessagesList:
      state.cafeDiscountsReducer.createCafeDiscountRequestFailedMessagesList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getMyCafeDailyWorkingHours: _ => dispatch(workingHoursActions.getMyCafeDailyWorkingHours()),
    createCafeDiscountRequest: reqObject =>
      dispatch(cafeDiscountsActions.createCafeDiscountRequest(reqObject)),
    clearCreateDiscountRequestForm: _ => dispatch(cafeDiscountsActions.clearCreateDiscountRequestForm())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CafeDiscounts);
